class SaleStripProduct extends HTMLElement {
  constructor() {
    super();
    this.endTime = Date.parse(this.dataset.endDatetime);
    this.textEl = this.querySelector('[data-countdown-text]');
    this.showMinutes = this.hasAttribute('data-show-minutes');
    this.colonFormat = this.hasAttribute('data-colon-format');
    this.showSeconds = this.hasAttribute('data-show-seconds');
  }

  connectedCallback() {
    if (isNaN(this.endTime)) return;
    this.tick();
    this.interval = setInterval(this.tick.bind(this), this.showSeconds ? 1000 : 60000);
  }

  disconnectedCallback() {
    if (this.interval) clearInterval(this.interval);
  }

  tick() {
    const remaining = this.endTime - Date.now();

    if (remaining <= 0) {
      clearInterval(this.interval);
      this.hidden = true;
      return;
    }

    const totalSeconds = Math.floor(remaining / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    let label;
    if (this.colonFormat) {
      label = `${days}d : ${String(hours).padStart(2, '0')}h : ${String(minutes).padStart(2, '0')}m`;
      if (this.showSeconds) {
        label += ` : ${String(seconds).padStart(2, '0')}s`;
      }
    } else if (this.showMinutes) {
      label = `${days}d ${String(hours).padStart(2, '0')}h ${String(minutes).padStart(2, '0')}m`;
    } else if (days > 0) {
      label = `${days}d ${hours}h`;
    } else if (hours > 0) {
      label = `${hours}h ${minutes}m`;
    } else {
      label = `${minutes}m`;
    }

    this.textEl.textContent = label;
  }
}

if (!customElements.get('sale-strip-product')) {
  customElements.define('sale-strip-product', SaleStripProduct);
}
